import { useCallback, useEffect } from 'react';

import { useCurrentProjectId, useUser } from '@adsk/alloy-provider';

import { useScheduleContext } from '../components/ScheduleProvider';
import { ACTIONS } from '../components/ScheduleProvider/ScheduleProvider';
import { fetchProjectSchedules } from '../scheduleSdk';
import { Schedule } from '../types';

export const useProjectSchedules = (): Schedule[] => {
  const projectId = useCurrentProjectId() as string;
  const { user } = useUser();

  const { schedules, dispatch } = useScheduleContext();

  const getSchedules = useCallback(async () => {
    dispatch({ type: ACTIONS.UPDATE_SCHEDULES_ERROR, payload: null });
    try {
      const res = await fetchProjectSchedules(projectId, user?.autodeskId);
      dispatch({ type: ACTIONS.UPDATE_SCHEDULES, payload: res });
    } catch {
      dispatch({ type: ACTIONS.UPDATE_SCHEDULES_ERROR, payload: getSchedules });
    }
  }, [dispatch, projectId, user?.autodeskId]);

  useEffect(() => {
    getSchedules();
  }, [projectId, getSchedules]);

  return schedules ?? [];
};
